/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpServerListRequest {
    getFixupPrototypeFunction() { return McpServerListRequest.fixupPrototype; }

    static newInstance(model: Partial<McpServerListRequest>): McpServerListRequest {
        let obj = Object.assign(new McpServerListRequest(), model);
        McpServerListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpServerListRequest>): McpServerListRequest {
        if (!model) return null;
        return McpServerListRequest.newInstance(<McpServerListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpServerListRequest) {
        if (!obj) return;

        models.McpServerListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpServerListRequest): boolean {
        Object.setPrototypeOf(obj, McpServerListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Filter by enabled/disabled status.
     */
    is_enabled: boolean;

}
